module.exports = __webpack_public_path__ + "static/media/proposition_1.034ee474.svg";